/**
 * EUDR HS Codes organized by category with translation keys
 * - Includes subheadings (6 digits) and chapters (47, 48).
 * - Partial codes are marked with isPartial = true (equivalent to 'ex ').
 * - In the FE, we send 'ex ' as prefix in the id when isPartial = true.
 */
import { EudrHsCodeItem } from '../types/eudrTypes';

export const EUDR_HS_CODES: Record<string, EudrHsCodeItem[]> = {
  cattle: [
    { code: '0102 21', translationKey: 'eudr.cattle.0102_21' },
    { code: '0102 29', translationKey: 'eudr.cattle.0102_29' },
    { code: '0201', translationKey: 'eudr.cattle.0201', isPartial: true }, // ex 0201
    { code: '0202', translationKey: 'eudr.cattle.0202', isPartial: true }, // ex 0202
    { code: '0206 10', translationKey: 'eudr.cattle.0206_10', isPartial: true }, // ex 0206 10
    { code: '0206 22', translationKey: 'eudr.cattle.0206_22', isPartial: true }, // ex 0206 22
    { code: '0206 29', translationKey: 'eudr.cattle.0206_29', isPartial: true }, // ex 0206 29
    { code: '1602 50', translationKey: 'eudr.cattle.1602_50', isPartial: true }, // ex 1602 50
    { code: '4101', translationKey: 'eudr.cattle.4101', isPartial: true }, // ex 4101
    { code: '4104', translationKey: 'eudr.cattle.4104', isPartial: true }, // ex 4104
    { code: '4107', translationKey: 'eudr.cattle.4107', isPartial: true }, // ex 4107
  ],
  cocoa: [
    { code: '1801', translationKey: 'eudr.cocoa.1801' },
    { code: '1802', translationKey: 'eudr.cocoa.1802' },
    { code: '1803', translationKey: 'eudr.cocoa.1803' },
    { code: '1804', translationKey: 'eudr.cocoa.1804' },
    { code: '1805', translationKey: 'eudr.cocoa.1805' },
    { code: '1806', translationKey: 'eudr.cocoa.1806' },
  ],
  coffee: [{ code: '0901', translationKey: 'eudr.coffee.0901' }],
  'oil-palm': [
    { code: '1207 10', translationKey: 'eudr.oilPalm.1207_10' },
    { code: '1511', translationKey: 'eudr.oilPalm.1511' },
    { code: '1513 21', translationKey: 'eudr.oilPalm.1513_21' },
    { code: '1513 29', translationKey: 'eudr.oilPalm.1513_29' },
    { code: '2306 60', translationKey: 'eudr.oilPalm.2306_60' },
    {
      code: '2905 45',
      translationKey: 'eudr.oilPalm.2905_45',
      isPartial: true,
    }, // ex 2905 45
    { code: '2915 70', translationKey: 'eudr.oilPalm.2915_70' },
    { code: '2915 90', translationKey: 'eudr.oilPalm.2915_90' },
    { code: '3823 11', translationKey: 'eudr.oilPalm.3823_11' },
    { code: '3823 12', translationKey: 'eudr.oilPalm.3823_12' },
    { code: '3823 19', translationKey: 'eudr.oilPalm.3823_19' },
    { code: '3823 70', translationKey: 'eudr.oilPalm.3823_70' },
  ],
  rubber: [
    { code: '4001', translationKey: 'eudr.rubber.4001' },
    { code: '4005', translationKey: 'eudr.rubber.4005', isPartial: true }, // ex 4005
    { code: '4006', translationKey: 'eudr.rubber.4006', isPartial: true }, // ex 4006
    { code: '4007', translationKey: 'eudr.rubber.4007', isPartial: true }, // ex 4007
    { code: '4008', translationKey: 'eudr.rubber.4008', isPartial: true }, // ex 4008
    { code: '4010', translationKey: 'eudr.rubber.4010', isPartial: true }, // ex 4010
    { code: '4011', translationKey: 'eudr.rubber.4011', isPartial: true }, // ex 4011
    { code: '4012', translationKey: 'eudr.rubber.4012', isPartial: true }, // ex 4012
    { code: '4013', translationKey: 'eudr.rubber.4013', isPartial: true }, // ex 4013
    { code: '4015', translationKey: 'eudr.rubber.4015', isPartial: true }, // ex 4015
    { code: '4016', translationKey: 'eudr.rubber.4016', isPartial: true }, // ex 4016
    { code: '4017', translationKey: 'eudr.rubber.4017', isPartial: true }, // ex 4017
  ],
  soya: [
    { code: '1201', translationKey: 'eudr.soya.1201' },
    { code: '1208 10', translationKey: 'eudr.soya.1208_10' },
    { code: '1507', translationKey: 'eudr.soya.1507' },
    { code: '2304', translationKey: 'eudr.soya.2304' },
  ],
  wood: [
    { code: '4401', translationKey: 'eudr.wood.4401' },
    { code: '4402', translationKey: 'eudr.wood.4402' },
    { code: '4403', translationKey: 'eudr.wood.4403' },
    { code: '4404', translationKey: 'eudr.wood.4404' },
    { code: '4405', translationKey: 'eudr.wood.4405' },
    { code: '4406', translationKey: 'eudr.wood.4406' },
    { code: '4407', translationKey: 'eudr.wood.4407' },
    { code: '4408', translationKey: 'eudr.wood.4408' },
    { code: '4409', translationKey: 'eudr.wood.4409' },
    { code: '4410', translationKey: 'eudr.wood.4410' },
    { code: '4411', translationKey: 'eudr.wood.4411' },
    { code: '4412', translationKey: 'eudr.wood.4412' },
    { code: '4413', translationKey: 'eudr.wood.4413' },
    { code: '4414', translationKey: 'eudr.wood.4414' },
    { code: '4415', translationKey: 'eudr.wood.4415' },
    { code: '4416', translationKey: 'eudr.wood.4416' },
    { code: '4417', translationKey: 'eudr.wood.4417' },
    { code: '4418', translationKey: 'eudr.wood.4418' },
    { code: '4419', translationKey: 'eudr.wood.4419' },
    { code: '4420', translationKey: 'eudr.wood.4420' },
    { code: '4421', translationKey: 'eudr.wood.4421' },
    // Pulp & paper – complete chapters
    { code: '47', translationKey: 'eudr.wood.47' },
    { code: '48', translationKey: 'eudr.wood.48' },
    // Partial
    { code: '49', translationKey: 'eudr.wood.49', isPartial: true }, // ex 49
    { code: '9401', translationKey: 'eudr.wood.9401', isPartial: true }, // ex 9401
    // Subdivisions of furniture and prefabricated
    { code: '9403 30', translationKey: 'eudr.wood.9403_30' },
    { code: '9403 40', translationKey: 'eudr.wood.9403_40' },
    { code: '9403 50', translationKey: 'eudr.wood.9403_50' },
    { code: '9403 60', translationKey: 'eudr.wood.9403_60' },
    { code: '9403 91', translationKey: 'eudr.wood.9403_91' },
    { code: '9406 10', translationKey: 'eudr.wood.9406_10' },
  ],
};

/**
 * Flat array of all EUDR HS codes for the dropdown
 */
export const EUDR_HS_CODES_FLAT: EudrHsCodeItem[] =
  Object.values(EUDR_HS_CODES).flat();

/**
 * Prefix for partial EUDR HS codes
 */
export const EUDR_PARTIAL_PREFIX = 'ex ';
